/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pages_Last_UpdatedInputs */

const en_common_pages_last_updated = /** @type {(inputs: Common_Pages_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated`)
};

const zh_common_pages_last_updated = /** @type {(inputs: Common_Pages_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近更新`)
};

/**
* | output |
* | --- |
* | "Last updated" |
*
* @param {Common_Pages_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_pages_last_updated = /** @type {((inputs?: Common_Pages_Last_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pages_Last_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_pages_last_updated(inputs)
	return zh_common_pages_last_updated(inputs)
});
export { common_pages_last_updated as "common.pages.last_updated" }